package com.example.positionahead.model

enum class DiscoverAssetClass {
    STOCK,
    ETF,
    BOND,
    MUTUAL_FUND,
}

enum class DiscoverSectionKind {
    FOR_YOUR_GOAL,
    STOCKS,
    ETFS,
    BONDS,
    MUTUAL_FUNDS,
    INCOME_OPPORTUNITIES,
}

data class DiscoverIdea(
    val symbol: String,
    val name: String,
    val assetClass: DiscoverAssetClass,
    val price: Double,
    val changePercent: Double,
    val dividendYield: Double,
    val whyConsider: String,
    val return1MonthPercent: Double? = null,
    val returnYtdPercent: Double? = null,
    val yearHigh: Double? = null,
    val yearLow: Double? = null,
    val peRatio: Double? = null,
    val researchSummary: String = "",
)

data class DiscoverSection(
    val kind: DiscoverSectionKind,
    val title: String,
    val subtitle: String? = null,
    val ideas: List<DiscoverIdea>,
)
